import Modal from "react-modal";
import * as theme from "../theme";
import CancelIcon from "@material-ui/icons/Cancel";
import {
  changeIsViewQuoteModalOpen,
  getCovers,
  getCoverTable,
} from "../store/quotes";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const ViewQuoteModal = ({
  clientneeds,
  covermathes,
  insurername,
  isopen,
  responseid,
}) => {
  const popupWidth = 50;
  const popupHeight = 80;

  const covers = useSelector(getCovers(responseid));
  const covertable = useSelector(getCoverTable);

  const readyTheCards = ({ covers, covertable }) => {
    // cover table is in object form
    // covers are also in object form
    //console.log(covers, "this is covers");
    let returnValueCards = {};
    for (let coverid in covertable) {
      if (returnValueCards[covertable[coverid].type]) {
        returnValueCards[covertable[coverid].type] = {
          ...returnValueCards[covertable[coverid].type],
          [coverid]: {
            ...covertable[coverid],
            covervalue: covers ? covers[coverid] : null,
          },
        };
      } else {
        returnValueCards[covertable[coverid].type] = {
          [coverid]: {
            ...covertable[coverid],
            covervalue: covers ? covers[coverid] : null,
          },
        };
      }
    }

    return returnValueCards;
  };

  //console.log(readyTheCards({ covers, covertable }));

  return (
    <Modal
      isOpen={isopen}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: `${popupHeight}vh`,
          width: `${popupWidth}vw`,
          position: "absolute",
          top: `${Math.floor((100 - popupHeight) / 2)}vh`,
          left: `${Math.floor((100 - popupWidth) / 2)}vw`,
          right: 0,
          bottom: 0,
          background: "white",
          WebkitOverflowScrolling: "touch",
          border: `8px solid ${theme.COLORS.primary_navyblue}`,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <ViewQuoteModalContent
        responseid={responseid}
        cards={readyTheCards({ covers, covertable })}
      ></ViewQuoteModalContent>
    </Modal>
  );
};

const ViewQuoteModalContent = ({ responseid, cards }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(
          changeIsViewQuoteModalOpen({
            responseid,
            value: false,
          })
        );
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch, responseid]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <CancelIcon
          fontSize="large"
          style={{ cursor: "pointer", color: theme.COLORS.primary_navyblue }}
          onClick={() => {
            dispatch(
              changeIsViewQuoteModalOpen({
                responseid,
                value: false,
              })
            );
          }}
        ></CancelIcon>
      </div>

      {Object.keys(cards).map((key) => {
        // if (key !== "Response")
        return <Card key={key} cardname={key} card={cards[key]}></Card>;
        // else return null;
      })}
    </div>
  );
};

const Card = ({ cardname, card }) => {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <hr />
      <div
        style={{
          height: "10vh",
          fontFamily: "GibsonSemiBd",
          fontSize: "1.9vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {cardname}
      </div>
      <hr />

      {Object.keys(card).map((coverid) => (
        <div key={coverid} style={{ height: "5vh" }}>
          {coverid} ---- {card[coverid].name["en"]} ----{" "}
          <span style={{ color: "red" }}>{card[coverid].covervalue}</span>
        </div>
      ))}
    </div>
  );
};

export default ViewQuoteModal;
